import { downIcon, upIcon } from './components/common/Icons';

export const LAB_VITAL_TESTS = [
    {
        id: 'locale-1685562631788',
        name: 'Complete Blood Count (CBC)',
        labVitals: [
            {
                id: 'lb-2139115007',
                name: 'Haemoglobin',
                unit_dislay_name: 'Hb (Hemoglobin)',
                unit: {
                    name: 'g/dL',
                    id: 'lu-31745967',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-205594306',
                name: 'RBC Count',
                unit_dislay_name: 'Total RBC Count',
                unit: {
                    name: '10*6/mm3',
                    id: 'lu-1594234413',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '10*6/mm3',
                        id: 'lu-1594234413',
                        ref_range: {},
                    },
                    {
                        name: '10*6/uL',
                        id: 'lu-7793362613',
                        ref_range: {},
                    },
                    {
                        name: '10*12/L',
                        id: 'lu-7793214371',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9501711298',
                name: 'PCV',
                unit_dislay_name: 'PCV (Packed Cell Volume)',
                unit: {
                    name: '%',
                    id: 'lu-998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                    {
                        name: 'fraction',
                        id: 'lu-781379780',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3943787415',
                name: 'MCV',
                unit_dislay_name: 'MCV (Mean Corpuscular Volume)',
                unit: {
                    name: 'fL',
                    id: 'lu-33029',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'fL',
                        id: 'lu-33029',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1199710156',
                name: 'MCHC (Mean Corpuscular Hemoglobin Concentration)',
                unit_dislay_name: 'MCHC (Mean Corpuscular Hemoglobin Concentration)',
                unit: {
                    name: 'g/dL',
                    id: 'lu-31745967',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-8901691783',
                name: 'MCH',
                unit_dislay_name: 'MCH (Mean Corpuscular Hemoglobin)',
                unit: {
                    name: 'pg',
                    id: 'lu-33366',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'pg',
                        id: 'lu-33366',
                        ref_range: {},
                    },
                    {
                        name: 'ng',
                        id: 'lu-33304',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-4395255485',
                name: 'Total WBC Count',
                unit_dislay_name: 'Total Leucocyte Count',
                unit: {
                    name: '10*3/mm3',
                    id: 'lu-1591463850',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '10*3/mm3',
                        id: 'lu-1591463850',
                        ref_range: {},
                    },
                    {
                        name: '10*9/L',
                        id: 'lu-8961079052',
                        ref_range: {},
                    },
                    {
                        name: '10*3/uL',
                        id: 'lu-7793273240',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-893658913',
                name: 'Absolute Eosinophil Count',
                unit_dislay_name: 'Eosinophils, Absolute Count',
                unit: {
                    name: '10*3/mm3',
                    id: 'lu-1591463850',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '10*3/mm3',
                        id: 'lu-1591463850',
                        ref_range: {},
                    },
                    {
                        name: '/uL',
                        id: 'lu-972391',
                        ref_range: {},
                    },
                    {
                        name: '10*9/L',
                        id: 'lu-8961079052',
                        ref_range: {},
                    },
                    {
                        name: '/mm3',
                        id: 'lu-30137507',
                        ref_range: {},
                    },
                    {
                        name: '10*3/uL',
                        id: 'lu-7793273240',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-7089331283',
                name: 'Lymphocyte Percentage',
                unit_dislay_name: 'Lymphocytes %',
                unit: {
                    name: '%',
                    id: 'lu-998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBCs',
                        id: 'lu-7610880605',
                        ref_range: {},
                    },
                    {
                        name: '%/100 WBC',
                        id: 'lu-1006470110',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBC',
                        id: 'lu-6374544541',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1260532616',
                name: 'Neutrophils %',
                unit_dislay_name: 'Neutrophils Percentage',
                unit: {
                    name: '%',
                    id: 'lu-998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBC',
                        id: 'lu-6374544541',
                        ref_range: {},
                    },
                    {
                        name: '%/100 WBC',
                        id: 'lu-1006470110',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBCs',
                        id: 'lu-7610880605',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5765582889',
                name: 'Eosinophils %',
                unit_dislay_name: 'Eosinophils Percentage',
                unit: {
                    name: '%',
                    id: 'lu-998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                    {
                        name: '%/100 WBC',
                        id: 'lu-1006470110',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBC',
                        id: 'lu-6374544541',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBCs',
                        id: 'lu-7610880605',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3416064576',
                name: 'Basophils %',
                unit_dislay_name: 'Basophils (%)',
                unit: {
                    name: '%',
                    id: 'lu-998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                    {
                        name: '%/100 WBC',
                        id: 'lu-1006470110',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBC',
                        id: 'lu-6374544541',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBCs',
                        id: 'lu-7610880605',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2913451153',
                name: 'Monocytes %',
                unit_dislay_name: 'Monocytes Percentage',
                unit: {
                    name: '%',
                    id: 'lu-998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                    {
                        name: '%/100 WBC',
                        id: 'lu-1006470110',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBCs',
                        id: 'lu-7610880605',
                        ref_range: {},
                    },
                    {
                        name: '/100 WBC',
                        id: 'lu-6374544541',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2577461804',
                name: 'Platelet Count',
                unit_dislay_name: 'Platelets (Platelet Count, PC)',
                unit: {
                    name: '10*3/mm3',
                    id: 'lu-1591463850',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '10*3/mm3',
                        id: 'lu-1591463850',
                        ref_range: {},
                    },
                    {
                        name: '10*3/uL',
                        id: 'lu-7793273240',
                        ref_range: {},
                    },
                    {
                        name: '10*9/L',
                        id: 'lu-8961079052',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-8109721066',
                name: 'Peripheral Smear Study',
                unit_dislay_name: 'PBS (Peripheral Blood Smear)',
            },
            {
                id: 'lb-7918188121',
                name: 'Erythrocyte Sedimentation Rate IN 1 Hour',
                unit_dislay_name: 'ESR (Erythrocyte Sedimentation Rate, 1 Hour)',
                unit: {
                    name: 'mm/h',
                    id: 'lu-31982680',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mm/h',
                        id: 'lu-31982680',
                        ref_range: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'locale-1685562631789',
        name: 'Diabetes Profile',
        labVitals: [
            {
                id: 'lb-5349691605',
                name: 'Fbs',
                unit_dislay_name: 'FBS (Fasting Blood Sugar), Plasma',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5528009855',
                name: 'PPBS',
                unit_dislay_name: 'PPBS (Post-Prandial Blood Sugar)',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9927104553',
                name: 'HbA1c',
                unit_dislay_name: 'HbA1c (Glycosylated Hemoglobin)',
                unit: {
                    name: '%',
                    id: 'lu-998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-7881503220',
                name: 'RBS (Random Blood Sugar)',
                unit_dislay_name: 'RBS (Random Blood Sugar)',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-6458044121',
                name: 'Mean Glucose Plasma',
                unit_dislay_name: 'Mean Blood Glucose',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5598295130',
                name: 'Glucose, Urine',
                unit_dislay_name: 'Glucose, Urine',
            },
            {
                id: 'lb-4042861880',
                name: 'Fasting Glucose, Urine',
                unit_dislay_name: 'Fasting Glucose, Urine',
            },
            {
                id: 'lb-1445983754',
                name: 'Post Prandial Urine Glucose',
                unit_dislay_name: '2 hr Post Meal Glucose, Urine (Presence)',
            },
        ],
    },
    {
        id: 'locale-1685562631790',
        name: 'Urine Routine and Microscopy',
        labVitals: [
            {
                id: 'lb-2405125688',
                name: 'Urine Color',
                unit_dislay_name: 'Colour, Urine',
            },
            {
                id: 'lb-7326011290',
                name: 'Odor, Urine',
                unit_dislay_name: 'Odor, Urine',
            },
            {
                id: 'lb-9797316110',
                name: 'Appearance, Urine',
                unit_dislay_name: 'Appearance, Urine',
            },
            {
                id: 'lb-1209059684',
                name: 'Specific Gravity OF Urine',
                unit_dislay_name: 'Specific Gravity, Urine',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-7438433728',
                name: 'pH, Urine',
                unit_dislay_name: 'pH, Urine',
            },
            {
                id: 'lb-5598295130',
                name: 'Glucose, Urine',
                unit_dislay_name: 'Glucose, Urine',
            },
            {
                id: 'lb-5485524191',
                name: 'Protein, Urine',
                unit_dislay_name: 'Protein, Urine',
            },
            {
                id: 'lb-5509235813',
                name: 'Ketones Urine',
                unit_dislay_name: 'Ketones, Urine',
            },
            {
                id: 'lb-6265670784',
                name: 'Blood (Hemoglobin), Urine',
                unit_dislay_name: 'Blood (Hemoglobin), Urine',
            },
            {
                id: 'lb-7282990879',
                name: 'Bile Salts, Urine',
                unit_dislay_name: 'Bile Salts, Urine',
            },
            {
                id: 'lb-1125720906',
                name: 'Bile Pigments, Urine',
                unit_dislay_name: 'Bile Pigments, Urine',
            },
            {
                id: 'lb-6923161313',
                name: 'Urobilinogen, Urine',
                unit_dislay_name: 'Urobilinogen, Urine',
            },
            {
                id: 'lb-1475632599',
                name: 'Nitrite, Urine',
                unit_dislay_name: 'Nitrite, Urine',
            },
            {
                id: 'lb-3520587015',
                name: 'Leucocyte Esterase, Urine',
                unit_dislay_name: 'Leucocyte Esterase, Urine',
            },
            {
                id: 'lb-1977247183',
                name: 'Pus Cells, Urine',
                unit_dislay_name: 'Pus Cells, Urine',
                unit: {
                    name: '/[HPF]',
                    id: 'lu-8944448716',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '/[HPF]',
                        id: 'lu-8944448716',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-6172445137',
                name: 'Epithelial Cells, Urine',
                unit_dislay_name: 'Epithelial Cells, Urine',
                unit: {
                    name: '/[HPF]',
                    id: 'lu-8944448716',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '/[HPF]',
                        id: 'lu-8944448716',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3868524033',
                name: 'RBC, Urine',
                unit_dislay_name: 'RBC, Urine',
                unit: {
                    name: '/[HPF]',
                    id: 'lu-8944448716',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '/[HPF]',
                        id: 'lu-8944448716',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3066498244',
                name: 'Crystals, Urine (Num/HPF)',
                unit_dislay_name: 'Crystals, Urine (Num/HPF)',
                unit: {
                    name: '/[HPF]',
                    id: 'lu-8944448716',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '/[HPF]',
                        id: 'lu-8944448716',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5856225720',
                name: 'Casts, Urine',
                unit_dislay_name: 'Casts, Urine',
            },
            {
                id: 'lb-7771099185',
                name: 'Bacteria, Urine',
                unit_dislay_name: 'Bacteria, Urine',
                unit: {
                    name: '/[HPF]',
                    id: 'lu-8944448716',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '/[HPF]',
                        id: 'lu-8944448716',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1269779072',
                name: 'Yeast, Urine',
                unit_dislay_name: 'Yeast, Urine',
                unit: {
                    name: '/[HPF]',
                    id: 'lu-8944448716',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '/[HPF]',
                        id: 'lu-8944448716',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-8141819893',
                name: 'Other Observation, Urine',
                unit_dislay_name: 'Other Observation, Urine',
            },
        ],
    },
    {
        id: 'locale-1685562631791',
        name: 'Kidney Function Test',
        labVitals: [
            {
                id: 'lb-123519403',
                name: 'Urea, Serum',
                unit_dislay_name: 'Urea, Serum',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-4216376455',
                name: 'Creatinine Serum',
                unit_dislay_name: 'Creatinine, Serum',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2575319787',
                name: 'Serum Uric Acid',
                unit_dislay_name: 'Uric Acid, Serum',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3321743197',
                name: 'BUN (Blood Urea Nitrogen)',
                unit_dislay_name: 'BUN (Blood Urea Nitrogen)',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-440571581',
                name: 'GFR Glomerular Filtration Rate Estimated',
                unit_dislay_name: 'eGFR (Glomerular Filtration Rate estimated)',
                unit: {
                    name: 'mL/min/ 1.73_m2',
                    id: 'lu-862988528',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mL/min/ 1.73_m2',
                        id: 'lu-862988528',
                        ref_range: {},
                    },
                    {
                        name: 'mL/min/(173.10*-2.m2)',
                        id: 'lu-8509228625',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2687404298',
                name: 'Serum Sodium',
                unit_dislay_name: 'Sodium (Na), Serum',
                unit: {
                    name: 'mmol/L',
                    id: 'lu-737267484',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mmol/L',
                        id: 'lu-737267484',
                        ref_range: {},
                    },
                    {
                        name: 'meq/L',
                        id: 'lu-991286487',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-4363578941',
                name: 'Serum Potassium',
                unit_dislay_name: 'Potassium (K), Serum',
                unit: {
                    name: 'mmol/L',
                    id: 'lu-737267484',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mmol/L',
                        id: 'lu-737267484',
                        ref_range: {},
                    },
                    {
                        name: 'meq/L',
                        id: 'lu-991286487',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-199044387',
                name: 'Serum Chloride',
                unit_dislay_name: 'Chloride (Cl), Serum',
                unit: {
                    name: 'mmol/L',
                    id: 'lu-737267484',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mmol/L',
                        id: 'lu-737267484',
                        ref_range: {},
                    },
                    {
                        name: 'meq/L',
                        id: 'lu-991286487',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9623637360',
                name: 'Serum Calcium Total',
                unit_dislay_name: 'Calcium, Serum',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-8797706528',
                name: 'Phosphorus Inorganic Serum',
                unit_dislay_name: 'Phosphorus, Serum',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-6375384604',
                name: 'Blood Bicarbonate',
                unit_dislay_name: 'Bicarbonate, blood (HCO3)',
                unit: {
                    name: 'mmol/L',
                    id: 'lu-737267484',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mmol/L',
                        id: 'lu-737267484',
                        ref_range: {},
                    },
                    {
                        name: 'meq/L',
                        id: 'lu-991286487',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-6498995314',
                name: 'Albumin, Spot Urine',
                unit_dislay_name: 'Albumin, Spot Urine',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'ug/mL',
                        id: 'lu-998672733',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3109374753',
                name: 'Creatinine, Spot Urine',
                unit_dislay_name: 'Creatinine, Spot Urine',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'ug/mL',
                        id: 'lu-998672733',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-7215008957',
                name: 'Microalbuminuria Test',
                unit_dislay_name: 'Microalbuminuria Test',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'ug/mL',
                        id: 'lu-998672733',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1289411964',
                name: 'Microalbumin Creatinine Ratio, Spot Urine',
                unit_dislay_name: 'Microalbumin Creatinine Ratio, Spot Urine',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-8179989245',
                name: 'Albumin Creatinine Ratio, Spot Urine',
                unit_dislay_name: 'Albumin Creatinine Ratio, Spot Urine',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'locale-1685562631792',
        name: 'Liver Function Test',
        labVitals: [
            {
                id: 'lb-2849949363',
                name: 'Total Bilirubin',
                unit_dislay_name: 'Total Bilirubin',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5000380966',
                name: 'Bilirubin Direct',
                unit_dislay_name: 'Direct Bilirubin',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2668091942',
                name: 'Bilirubin Indirect',
                unit_dislay_name: 'Indirect Bilirubin',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9359258775',
                name: 'AST or SGOT (Aspartate Aminotransferase)',
                unit_dislay_name: 'AST or SGOT (Aspartate Aminotransferase)',
                unit: {
                    name: 'U/L',
                    id: 'lu-1006739',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'U/L',
                        id: 'lu-1006739',
                        ref_range: {},
                    },
                    {
                        name: '[IU]/L',
                        id: 'lu-187907029',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2085199936',
                name: 'Alanine Transaminase alt / SGPT',
                unit_dislay_name: 'ALT or SGPT (Alanine Aminotransferase)',
                unit: {
                    name: 'U/L',
                    id: 'lu-1006739',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'U/L',
                        id: 'lu-1006739',
                        ref_range: {},
                    },
                    {
                        name: '[IU]/L',
                        id: 'lu-187907029',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9363184428',
                name: 'SGOT/SGPT Ratio',
                unit_dislay_name: 'SGOT/SGPT Ratio',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9356134692',
                name: 'Alkaline Phosphatase ALP',
                unit_dislay_name: 'ALP (Alkaline Phosphatase)',
                unit: {
                    name: 'U/L',
                    id: 'lu-1006739',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'U/L',
                        id: 'lu-1006739',
                        ref_range: {},
                    },
                    {
                        name: '[IU]/L',
                        id: 'lu-187907029',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1411018949',
                name: 'Protein Total',
                unit_dislay_name: 'Total Protein',
                unit: {
                    name: 'g/dL',
                    id: 'lu-31745967',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9459377241',
                name: 'Albumin Serum',
                unit_dislay_name: 'Albumin, Serum',
                unit: {
                    name: 'g/dL',
                    id: 'lu-31745967',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3421135860',
                name: 'Globulin, Serum',
                unit_dislay_name: 'Globulin, Serum',
                unit: {
                    name: 'g/dL',
                    id: 'lu-31745967',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2050335586',
                name: 'Albumin / Globulin Ratio',
                unit_dislay_name: 'A/G Ratio (Albumin / Globulin Ratio)',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2314058548',
                name: 'Gamma Glutamyl Transferase GGT',
                unit_dislay_name: 'GGT (Gamma-glutamyl Transferase)',
                unit: {
                    name: 'U/L',
                    id: 'lu-1006739',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'U/L',
                        id: 'lu-1006739',
                        ref_range: {},
                    },
                    {
                        name: '[IU]/L',
                        id: 'lu-187907029',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1988613797',
                name: 'Magnesium',
                unit_dislay_name: 'Magnesium, Serum',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'locale-1685562631793',
        name: 'Lipid Profile',
        labVitals: [
            {
                id: 'lb-2895482211',
                name: 'Cholesterol Total*',
                unit_dislay_name: 'Cholesterol Total*',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                },
            },
            {
                id: 'lb-4239229218',
                name: 'HDL Cholesterol Direct',
                unit_dislay_name: 'HDL Cholesterol, Direct',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-4653601804',
                name: 'LDL Cholesterol,Direct*',
                unit_dislay_name: 'LDL Cholesterol,Direct*',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                },
            },
            {
                id: 'lb-3227824597',
                name: 'Triglycerides*',
                unit_dislay_name: 'Triglycerides*',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                },
            },
            {
                id: 'lb-8134767286',
                name: 'VLDL Cholesterol*',
                unit_dislay_name: 'VLDL Cholesterol*',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                },
            },
            {
                id: 'lb-8027757268',
                name: 'Non-HDL Cholesterol*',
                unit_dislay_name: 'Non-HDL Cholesterol*',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                },
            },
            {
                id: 'lb-9863069195',
                name: 'Cholesterol Total / HDL Cholesterol Ratio',
                unit_dislay_name: 'Total Cholesterol / HDL Cholesterol Ratio',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-8917821309',
                name: 'Triglyceride / HDL Cholesterol Ratio',
                unit_dislay_name: 'Triglyceride / HDL Cholesterol Ratio',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-7362139421',
                name: 'LDL Cholesterol / HDL Cholesterol Ratio',
                unit_dislay_name: 'LDL Cholesterol / HDL Cholesterol Ratio',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5883793738',
                name: 'HDL/LDL ratio (HDL Cholesterol/LDL Cholesterol Ratio)',
                unit_dislay_name: 'HDL/LDL ratio (HDL Cholesterol/LDL Cholesterol Ratio)',
                unit: {
                    name: 'ratio',
                    id: 'lu-5410855278',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ratio',
                        id: 'lu-5410855278',
                        ref_range: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'locale-1685562631794',
        name: 'Thyroid Function Profile',
        labVitals: [
            {
                id: 'lb-9604959198',
                name: 'Thyroid Stimulating Hormone TSH',
                unit_dislay_name: 'TSH (Thyroid Stimulating Hormone)',
                unit: {
                    name: 'u[IU]/mL',
                    id: 'lu-1532096096',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'u[IU]/mL',
                        id: 'lu-1532096096',
                        ref_range: {},
                    },
                    {
                        name: 'm[IU]/L',
                        id: 'lu-2304231680',
                        ref_range: {},
                    },
                    {
                        name: 'u[IU]/L',
                        id: 'lu-9404261128',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-6980696040',
                name: 'Thyroxine Total T4',
                unit_dislay_name: 'T4, Total (Thyroxine)',
                unit: {
                    name: 'ug/dL',
                    id: 'lu-998672454',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ug/dL',
                        id: 'lu-998672454',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9797960000',
                name: 'Triiodothyronine T3 Total',
                unit_dislay_name: 'T3, Total (Triiodothyronine)',
                unit: {
                    name: 'ng/dL',
                    id: 'lu-992207807',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/dL',
                        id: 'lu-992207807',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3934699069',
                name: 'Thyroxine T4 Free',
                unit_dislay_name: 'Free T4',
                unit: {
                    name: 'ng/dL',
                    id: 'lu-992207807',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/dL',
                        id: 'lu-992207807',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-8372008953',
                name: 'Free T3 Triiodothyronine Free T3',
                unit_dislay_name: 'T3, Free (Triiodothyronine)',
                unit: {
                    name: 'pg/mL',
                    id: 'lu-994055128',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'pg/mL',
                        id: 'lu-994055128',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9348420641',
                name: 'Anti TPO Antibody',
                unit_dislay_name: 'Anti TPO Antibody',
                unit: {
                    name: '[IU]/mL',
                    id: 'lu-5825118998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '[IU]/mL',
                        id: 'lu-5825118998',
                        ref_range: {},
                    },
                    {
                        name: "[arb'U]/mL",
                        id: 'lu-7557672463',
                        ref_range: {},
                    },
                    {
                        name: 'U/L',
                        id: 'lu-1006739',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5916316310',
                name: 'Thyroglobulin Antibody, Serum (Quantitative)',
                unit_dislay_name: 'Thyroglobulin Antibody, Serum (Quantitative)',
                unit: {
                    name: '[IU]/mL',
                    id: 'lu-5825118998',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: '[IU]/mL',
                        id: 'lu-5825118998',
                        ref_range: {},
                    },
                    {
                        name: "[arb'U]/mL",
                        id: 'lu-7557672463',
                        ref_range: {},
                    },
                    {
                        name: 'U/L',
                        id: 'lu-1006739',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-7799412041',
                name: 'Thyroglobulin Antibody, Serum (Qualitative)',
                unit_dislay_name: 'Thyroglobulin Antibody, Serum (Qualitative)',
            },
        ],
    },
    {
        id: 'locale-1685562631795',
        name: 'Fertility/PCOS Profile',
        labVitals: [
            {
                id: 'lb-5349314329',
                name: 'FSH Follicle Stimulating Hormone',
                unit_dislay_name: 'FSH (Follicle Stimulating Hormone) Test',
                unit: {
                    name: 'm[IU]/mL',
                    id: 'lu-1431183186',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'm[IU]/mL',
                        id: 'lu-1431183186',
                        ref_range: {},
                    },
                    {
                        name: 'U/L',
                        id: 'lu-1006739',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-25533077',
                name: 'LH',
                unit_dislay_name: 'LH (Luteinizing Hormone)',
                unit: {
                    name: 'm[IU]/mL',
                    id: 'lu-1431183186',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'm[IU]/mL',
                        id: 'lu-1431183186',
                        ref_range: {},
                    },
                    {
                        name: 'U/L',
                        id: 'lu-1006739',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3540033297',
                name: 'Prolactin',
                unit_dislay_name: 'Prolactin, Serum',
                unit: {
                    name: 'ng/mL',
                    id: 'lu-992208086',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/mL',
                        id: 'lu-992208086',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5493303723',
                name: 'Free Testosterone, Serum (Mass/Vol)',
                unit_dislay_name: 'Free Testosterone, Serum (Mass/Vol)',
                unit: {
                    name: 'pg/mL',
                    id: 'lu-994055128',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'pg/mL',
                        id: 'lu-994055128',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3982560831',
                name: 'Testosterone, Serum',
                unit_dislay_name: 'Testosterone, Serum',
                unit: {
                    name: 'ng/dL',
                    id: 'lu-992207807',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/dL',
                        id: 'lu-992207807',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2502934222',
                name: 'DHT (Dihydrotestosterone)',
                unit_dislay_name: 'DHT (Dihydrotestosterone)',
                unit: {
                    name: 'ng/dL',
                    id: 'lu-992207807',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/dL',
                        id: 'lu-992207807',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1391182436',
                name: 'Androstenedione',
                unit_dislay_name: 'Androstenedione',
                unit: {
                    name: 'ng/mL',
                    id: 'lu-992208086',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/mL',
                        id: 'lu-992208086',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2236938219',
                name: 'DHEA, Serum',
                unit_dislay_name: 'DHEA, Serum',
                unit: {
                    name: 'ng/dL',
                    id: 'lu-992207807',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/dL',
                        id: 'lu-992207807',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5443318400',
                name: 'Progesterone, Serum',
                unit_dislay_name: 'Progesterone, Serum',
                unit: {
                    name: 'ng/mL',
                    id: 'lu-992208086',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/mL',
                        id: 'lu-992208086',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-4098259837',
                name: '17 Hydroxy Prog - 17 Hydroxy Progesterone',
                unit_dislay_name: '17-OH Progesterone, Serum',
                unit: {
                    name: 'ng/dL',
                    id: 'lu-992207807',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'ng/dL',
                        id: 'lu-992207807',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-7018385109',
                name: 'SHBG',
                unit_dislay_name: 'SHBG (Sex Hormone Binding Globulin) (Moles/Vol)',
                unit: {
                    name: 'nmol/L',
                    id: 'lu-765896635',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'nmol/L',
                        id: 'lu-765896635',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-6061378155',
                name: 'Estradiol Test',
                unit_dislay_name: 'Estradiol Test',
                unit: {
                    name: 'pg/mL',
                    id: 'lu-994055128',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'pg/mL',
                        id: 'lu-994055128',
                        ref_range: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'locale-1685562631796',
        name: 'Routine Imaging and Histopath',
        labVitals: [
            {
                id: 'lb-2958577545',
                name: 'ECG Electrocardiogram',
                unit_dislay_name: 'ECG',
            },
            {
                id: 'lb-30751428',
                name: 'echo',
                unit_dislay_name: '2-D ECHO',
            },
            {
                id: 'lb-5176055409',
                name: 'X-Ray Chest PA View',
                unit_dislay_name: 'X-Ray Chest -  PA View',
            },
            {
                id: 'lb-9426706044',
                name: 'Abdomen And Pelvis Ultrasound',
                unit_dislay_name: 'USG Abdomen and Pelvis',
            },
            {
                id: 'lb-6963066861',
                name: 'USG',
                unit_dislay_name: 'USG (Ultrasonography)',
            },
            {
                id: 'lb-5260473493',
                name: 'FNAC',
                unit_dislay_name: 'FNAC',
            },
            {
                id: 'lb-1534734104',
                name: 'Histopathology Report',
                unit_dislay_name: 'Histopathology Report',
            },
            {
                id: 'lb-6009180771',
                name: 'Biopsy Report',
                unit_dislay_name: 'Biopsy Report',
            },
        ],
    },
    {
        id: 'locale-1685562631797',
        name: 'Blood grp & Serology',
        labVitals: [
            {
                id: 'lb-6248028943',
                name: 'ABO Grouping and Typing',
                unit_dislay_name: 'ABO Grouping and Typing',
            },
            {
                id: 'lb-956255647',
                name: 'HIV I',
                unit_dislay_name: 'HIV I',
            },
            {
                id: 'lb-9643925132',
                name: 'HIV II',
                unit_dislay_name: 'HIV II',
            },
            {
                id: 'lb-6137515437',
                name: 'HBsAg (Hepatitis B Surface Antigen)',
                unit_dislay_name: 'HBsAg (Hepatitis B Surface Antigen)',
            },
            {
                id: 'lb-3940380407',
                name: 'Hepatitis C - Total Antibodies, Serum (Qualitative)',
                unit_dislay_name: 'Hepatitis C - Total Antibodies, Serum (Qualitative)',
            },
            {
                id: 'lb-2757322943',
                name: 'VDRL Test',
                unit_dislay_name: 'VDRL Test',
            },
        ],
    },
    {
        id: 'locale-1685562631798',
        name: 'Serum Electrolytes',
        labVitals: [
            {
                id: 'lb-2687404298',
                name: 'Sodium',
                unit_dislay_name: 'Sodium (Na), Serum',
                unit: {
                    name: 'mmol/L',
                    id: 'lu-737267484',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mmol/L',
                        id: 'lu-737267484',
                        ref_range: {},
                    },
                    {
                        name: 'meq/L',
                        id: 'lu-991286487',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-4363578941',
                name: 'Potassium',
                unit_dislay_name: 'Potassium (K), Serum',
                unit: {
                    name: 'mmol/L',
                    id: 'lu-737267484',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mmol/L',
                        id: 'lu-737267484',
                        ref_range: {},
                    },
                    {
                        name: 'meq/L',
                        id: 'lu-991286487',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-199044387',
                name: 'Chloride',
                unit_dislay_name: 'Chloride (Cl), Serum',
                unit: {
                    name: 'mmol/L',
                    id: 'lu-737267484',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mmol/L',
                        id: 'lu-737267484',
                        ref_range: {},
                    },
                    {
                        name: 'meq/L',
                        id: 'lu-991286487',
                        ref_range: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'locale-1685562631799',
        name: 'Vitamin & Minerals',
        labVitals: [
            {
                id: 'lb-5163005287',
                name: 'VITAMIN D (25 OH VITAMIN D)',
                unit_dislay_name: 'VITAMIN D (25 OH VITAMIN D)',
                unit: {
                    name: 'ng/ml',
                    id: 'lu-992208086',
                },
            },
            {
                id: 'lb-6907652548',
                name: 'B12 Vitamin',
                unit_dislay_name: 'Vitamin B12',
                unit: {
                    name: 'pg/mL',
                    id: 'lu-994055128',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'pg/mL',
                        id: 'lu-994055128',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9623637360',
                name: 'Calcium',
                unit_dislay_name: 'Calcium, Serum',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1988613797',
                name: 'Magnesium',
                unit_dislay_name: 'Magnesium, Serum',
                unit: {
                    name: 'mg/dL',
                    id: 'lu-991284286',
                    ref_range: {},
                },
                all_units: [
                    {
                        name: 'mg/dL',
                        id: 'lu-991284286',
                        ref_range: {},
                    },
                    {
                        name: 'g/L',
                        id: 'lu-1024037',
                        ref_range: {},
                    },
                    {
                        name: 'mg/mL',
                        id: 'lu-991284565',
                        ref_range: {},
                    },
                    {
                        name: 'mg/L',
                        id: 'lu-31976886',
                        ref_range: {},
                    },
                    {
                        name: 'g/dL',
                        id: 'lu-31745967',
                        ref_range: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'locale-1685562631800',
        name: 'Fever Profile',
        labVitals: [
            {
                id: 'lb-9190011815',
                name: 'Malarial parasite Antigen Test',
                unit_dislay_name: 'Malarial parasite Antigen Test',
            },
            {
                id: 'lb-8109721066',
                name: 'PS -Peripheral Smear',
                unit_dislay_name: 'PBS (Peripheral Blood Smear)',
            },
            {
                id: 'lb-2876498504',
                name: 'Dengue Antigen NS1 Antigen',
                unit_dislay_name: 'Dengue NS-1 (Qualitative)',
            },
            {
                id: 'lb-5550358506',
                name: 'Dengue IgG',
                unit_dislay_name: 'Dengue IgG, Serum (Qualitative)',
            },
            {
                id: 'lb-2026763499',
                name: 'Dengue IgM',
                unit_dislay_name: 'Dengue IgM, Serum (Qualitative)',
            },
            {
                id: 'lb-4553193457',
                name: 'Widal',
                unit_dislay_name: 'Widal (Slide Test)',
            },
            {
                id: 'lb-1710710397',
                name: 'Typhidot G Test',
                unit_dislay_name: 'Typhidot G Test',
            },
            {
                id: 'lb-4131601557',
                name: 'Typhidot M Test',
                unit_dislay_name: 'Typhidot M Test',
            },
            {
                id: 'lb-7633061558',
                name: 'SARS Cov-2 RNA (Presence)',
                unit_dislay_name: 'SARS Cov-2 RNA (Presence)',
            },
        ],
    },
    {
        id: 'locale-1685562631801',
        name: 'Iron Profile',
        labVitals: [
            {
                id: 'lb-750278684',
                name: 'Iron, Serum',
                unit_dislay_name: 'Iron, Serum',
                all_units: [
                    {
                        name: 'ug/dL',
                        id: 'lu-998672454',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-8584733439',
                name: 'Iron Binding Capacity',
                unit_dislay_name: 'TIBC (Total Iron Binding Capacity)',
                all_units: [
                    {
                        name: 'ug/dL',
                        id: 'lu-998672454',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-1656398442',
                name: 'UIBC (Unsaturated Iron Binding Capacity)',
                unit_dislay_name: 'UIBC (Unsaturated Iron Binding Capacity)',
                all_units: [
                    {
                        name: 'ug/dL',
                        id: 'lu-998672454',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-865313635',
                name: 'Transferrin %',
                unit_dislay_name: 'Transferrin Saturation, Serum',
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                    {
                        name: 'fraction',
                        id: 'lu-781379780',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-3422462170',
                name: 'Ferritin Serum',
                unit_dislay_name: 'Ferritin, Serum',
                all_units: [
                    {
                        name: 'ng/mL',
                        id: 'lu-992208086',
                        ref_range: {},
                    },
                ],
            },
        ],
    },
    {
        id: 'locale-1685562631802',
        name: 'Pulmonary Function Tests',
        labVitals: [
            {
                id: 'lb-8385334048',
                name: 'Forced Vital Capacity (FVC)',
                unit_dislay_name: 'Forced Vital Capacity (FVC)',
                all_units: [
                    {
                        name: 'mL',
                        id: 'lu-33246',
                        ref_range: {},
                    },
                    {
                        name: 'L',
                        id: 'lu-1037',
                        ref_range: {},
                    },
                    {
                        name: 'dL',
                        id: 'lu-32967',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-30783545',
                name: 'FEV1',
                unit_dislay_name: 'FEV1',
                all_units: [
                    {
                        name: 'mL',
                        id: 'lu-33246',
                        ref_range: {},
                    },
                    {
                        name: 'L',
                        id: 'lu-1037',
                        ref_range: {},
                    },
                    {
                        name: 'dL',
                        id: 'lu-32967',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-9251734967',
                name: 'FEV1/FVC',
                unit_dislay_name: 'FEV1/FVC',
                all_units: [
                    {
                        name: '%',
                        id: 'lu-998',
                        ref_range: {},
                    },
                    {
                        name: 'fraction',
                        id: 'lu-781379780',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2697724732',
                name: 'Vital Capacity (VC)',
                unit_dislay_name: 'Vital Capacity (VC)',
                all_units: [
                    {
                        name: 'mL',
                        id: 'lu-33246',
                        ref_range: {},
                    },
                    {
                        name: 'dL',
                        id: 'lu-32967',
                        ref_range: {},
                    },
                    {
                        name: 'L',
                        id: 'lu-1037',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-2461974911',
                name: 'Forced Expiratory Time (FET)',
                unit_dislay_name: 'Forced Expiratory Time (FET)',
                all_units: [
                    {
                        name: 's',
                        id: 'lu-1076',
                        ref_range: {},
                    },
                    {
                        name: 'min',
                        id: 'lu-1031635',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-5190784051',
                name: 'PEFR (Peak Expiratory Flow Rate)',
                unit_dislay_name: 'PEFR (Peak Expiratory Flow Rate)',
            },
            {
                id: 'lb-6376443074',
                name: 'Inspiratory Capacity (IC)',
                unit_dislay_name: 'Inspiratory Capacity (IC)',
                all_units: [
                    {
                        name: 'mL',
                        id: 'lu-33246',
                        ref_range: {},
                    },
                    {
                        name: 'L',
                        id: 'lu-1037',
                        ref_range: {},
                    },
                    {
                        name: 'dL',
                        id: 'lu-32967',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-953814317',
                name: 'FENO-Fractional Exhaled Nitric Oxide Test',
                unit_dislay_name: 'Exhaled Nitric Oxide (NO) Test',
                all_units: [
                    {
                        name: '[ppb]',
                        id: 'lu-974991447',
                        ref_range: {},
                    },
                    {
                        name: '[ppm] v/v',
                        id: 'lu-7242360677',
                        ref_range: {},
                    },
                    {
                        name: '[ppm]',
                        id: 'lu-974991788',
                        ref_range: {},
                    },
                ],
            },
            {
                id: 'lb-4637465182',
                name: 'Six Minute Walk Test',
                unit_dislay_name: 'Six Minute Walk Test',
            },
        ],
    },
];

export const LAB_VITAL_LOW_HIGH_ABNORMAL_INTERPRETATION: {
    [k: string]: {
        message: string;
        status: string;
        icon?: JSX.Element;
    };
} = {
    'sm-4067205096': {
        message: 'Critically High',
        status: 'high',
        icon: upIcon,
    },
    'sm-2631712380': {
        message: 'Very High',
        status: 'high',
        icon: upIcon,
    },
    'sm-1420480405': {
        message: 'High',
        status: 'high',
        icon: upIcon,
    },
    'sm-5279215230': {
        message: 'Borderline High',
        status: 'high',
        icon: upIcon,
    },
    'sm-5279274814': {
        message: 'Borderline Low',
        status: 'low',
        icon: downIcon,
    },
    'sm-1220479757': {
        message: 'Low',
        status: 'low',
        icon: downIcon,
    },
    'sm-2631771970': {
        message: 'Very Low',
        status: 'low',
        icon: downIcon,
    },
    'sm-4067860500': {
        message: 'Critically Low',
        status: 'low',
        icon: downIcon,
    },
    'sm-5379306527': {
        message: 'Abnormal',
        status: 'abnormal',
        icon: undefined,
    },
};
